// Enumerations
import { RoutesCommonEnumeration } from 'enumerations/routes.common.enumeration';
import { CharactersEnum } from '@openbank/cf-ui-static-data';
import { RoutesEnumeration } from 'enumerations/routes.enumeration';
// Constants
import { EMPTY_STRING } from 'utils/constants/utils.constants';

const generatePathRoute = (routes: string[]): string => routes.join(CharactersEnum.SLASH);

const generateAbsoluteRoute = (route: string): string => `${CharactersEnum.SLASH}${route}`;

const getPathnameFromBrowser = (): string => {
  const splitUrl = sanitizeUrl(window.location.pathname);

  return splitUrl[splitUrl.length - 1];
};

const getPathnameByLocation = (pathname: string): string => {
  const splitUrl = sanitizeUrl(pathname);

  return splitUrl[splitUrl.length - 1];
};

const sanitizeUrl = (pathname: string): string[] =>
  pathname.split('/').filter((path: string) => !path.includes(':'));

const isBaseRootPath = (path: string): boolean => path === CharactersEnum.SLASH;

const getLastRouteSegment = (path: string): string =>
  path.split(CharactersEnum.SLASH).filter(Boolean).pop() || EMPTY_STRING;

const isRouteSelected = (pathname: string, href: string): boolean =>
  Boolean(href) && getLastRouteSegment(pathname) === getLastRouteSegment(href);

const isDashboardRoute = (path: string): boolean =>
  path === CharactersEnum.SLASH + RoutesEnumeration.DASHBOARD;

const isSecondLevelRoutePath = (): boolean => {
  const routeWithoutBasePath = window.location.pathname.replace(
    `${CharactersEnum.SLASH}${RoutesCommonEnumeration.BASE_PATH}`,
    ''
  );
  return Boolean(routeWithoutBasePath.split(CharactersEnum.SLASH).filter(Boolean).length > 1);
};

const getLastPathNameUrlItem = (): string =>
  getPathnameFromBrowser().split(CharactersEnum.SLASH).pop()!;

const getPreviousPathName = (breadCrumbPath?: string): string =>
  (Object.values(RoutesEnumeration).find(path => path === breadCrumbPath) as string) ||
  EMPTY_STRING;

export {
  generateAbsoluteRoute,
  generatePathRoute,
  getLastPathNameUrlItem,
  getLastRouteSegment,
  getPathnameByLocation,
  getPathnameFromBrowser,
  getPreviousPathName,
  isBaseRootPath,
  isDashboardRoute,
  isRouteSelected,
  isSecondLevelRoutePath,
};
